import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useState } from "react";

import { connect } from "react-redux";

const ScholarshipCriteriaDialog = (props) => {
  const { showDialog, setShowDialog } = props;
  return (
    <Dialog
      onClose={() => setShowDialog(false)}
      open={showDialog}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle className="text-primary">
        <Typography
          variant="overline"
          className="text-truncate"
          display="block"
          style={{ maxWidth: "90%" }}
        >
          <h6 className="text-primary font-weight-bold">
            Scholarship selection criteria
          </h6>
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setShowDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ minHeight: "55vh" }}>
          <h6>
            In the selection process, the following criteria were put into
            consideration:
          </h6>
          <ol style={{ paddingTop: "15px" }}>
            <li>
              Teachers who uploaded all required documents were temporally
              shortlisted
            </li>
            <li>
              Candidates who successfully passed the subjects related to their
              desired department of study were temporally shortlisted; only
              grades A, B, C, and D were considered
            </li>
            <li>
              Having succeeded in the Selection Test, after being shortlisted at
              the first level, candidates were selected
            </li>
            <li>
              During the selection process, 300 candidates who scored at/or
              above 50% were selected and distributed in departments applied for
              as follows: 33% (99) in Early Childhood Education, 9% (27) in
              Special Needs Education, 31% (92= 24 A2 and 68 A1) in Sciences
              with Education, 27% (82= 73 A2 and 9 A1) in Arts and Languages
            </li>
            <li>
              A1 candidates were allocated only in Sciences with Education and
              in Arts and Languages
            </li>
            <li>The ranking was done at the National level</li>
            <li>
              The Candidates with the highest score (as per the results) were
              prioritized
            </li>
            <li>
              <strong>
                In case two or more candidates had equal marks, the following
                criteria were put into consideration:
              </strong>
              <ul>
                <li>Less represented gender was prioritized</li>
                <li>
                  Candidates with more experience than others were prioritized
                </li>
                <li>Candidates with younger age were prioritized</li>
                <li>
                  If the candidates intersected these criteria, time of
                  application was considered
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center pb-3 pt-0"></DialogActions>
    </Dialog>
  );
};

export default ScholarshipCriteriaDialog;
